module.exports = __webpack_public_path__ + "img/phone-call-icon.77e4f1fa.svg";